// auth.ts
export const isAuthenticated = () => {
    console.log("Checking authentication status...");

    // For example: check if token exists
    return !!localStorage.getItem("user_token");
};

export const isCustomerAuthenticated = () => {
    return !!localStorage.getItem("customer_token");
};
